module.exports = __webpack_public_path__ + "static/media/header-landing-pages-logo.a2c3b5a5.svg";